import sdl from '@jds/react-generated-sdl/JDSRatingBarItem';
import type { JDSRatingBarItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSRatingBarItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'medium',
    isInteractive = false,
    isActive = false,
    isHovered = false,
    isHalfRated = false,
    disabled = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      size,
      isInteractive,
      isActive,
      isHovered,
      isHalfRated,
      disabled,
      ...rest
    },
    'JDSRatingBarItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const RatingBarItem = withLogic(
  Component
) as React.FC<JDSRatingBarItemProps> & { slotName?: string };

RatingBarItem.displayName = 'RatingBarItem';
RatingBarItem.slotName = 'jds_rating_bar_item';

export { RatingBarItem, type JDSRatingBarItemProps };
